@if ($product(); as product) {
  <section
    #summaryContainer
    [ngClass]="{ 'no-collapse': !$collapsable() }"
    class="collapse-container"
    [@collapse]="!$isExpanded()"
    [attr.aria-expanded]="$isExpanded()"
  >
    <div [innerHTML]="product.description | safeHtml" class="summary"></div>
  </section>
  <div [ngClass]="{ 'no-collapse-buttons': !$collapsable() }">
    <button class="btn-collapse" (click)="toggle()">
      @if (!$isExpanded()) {
        {{ 'productDetails.btnReadMore' | transloco }}
        <fa-icon [icon]="faCaretDown"></fa-icon>
      } @else {
        {{ 'productDetails.btnReadLess' | transloco }}
        <fa-icon [icon]="faCaretUp"></fa-icon>
      }
    </button>
  </div>

  <div class="row summary-block">
    <div class="col">
      @if (product.unitPrices?.length && product.price?.value !== 0) {
        @if ($isPlatformBrowser()) {
          <div class="price-label">
            <span>{{ 'productDetails.labelFrom' | transloco }}</span>
            <span class="price-block price-block--last price-label--normal">
              ({{ $label() | transloco }})
            </span>
          </div>
          <div class="price-container">
            @if ($unitPrices().length) {
              @for (priceObj of $unitPrices(); track priceObj) {
                <div class="price-block">
                  <span>{{ priceObj.unitName }}</span>
                  <span class="price price--{{ priceObj.unit }}">{{
                    priceObj.formattedValue
                  }}</span>
                </div>
              }
            }
          </div>
        } @else {
          <boels-skeleton
            [inputHeight]="48"
            [inputStyle]="{ borderRadius: '4px' }"
            [runOnServer]="true"
          ></boels-skeleton>
        }
      }
      @if (!product.unitPrices?.length || product.price?.value === 0) {
        <div class="price-container">
          <div class="price-block">
            {{ 'productDetails.labelPrice' | transloco }}
            <span class="price price--day">{{
              'productDetails.labelPriceOnApplication' | transloco
            }}</span>
          </div>
        </div>
      }
    </div>

    @if ($mandatoryAccessories().length) {
      <div class="col price-container__accessories" @fadeIn>
        @if ($mandatoryAccessories().length === 1) {
          {{ 'productDetails.pdpAddToBookingNotice_prefix_single' | transloco }}
          <span
            class="accessory-count"
            boelsQa="mandatory-accessory-count-single"
          >
            {{
              'productDetails.pdpAddToBookingNotice_single'
                | transloco: { count: $mandatoryAccessories().length }
            }}
          </span>
          {{ 'productDetails.pdpAddToBookingNotice_suffix' | transloco }}
        } @else {
          {{ 'productDetails.pdpAddToBookingNotice_prefix_plural' | transloco }}
          <span
            class="accessory-count"
            boelsQa="mandatory-accessory-count-plural"
          >
            {{
              'productDetails.pdpAddToBookingNotice_plural'
                | transloco: { count: $mandatoryAccessories().length }
            }}
          </span>
          {{ 'productDetails.pdpAddToBookingNotice_suffix' | transloco }}
        }
        <p>
          <ng-template #content>
            {{
              'productDetails.pdpAddToBookingNotice_prefix_single' | transloco
            }}
            <span
              class="accessory-count"
              boelsQa="mandatory-accessory-count-template"
            >
              {{
                'productDetails.pdpAddToBookingNotice_single'
                  | transloco: { count: $mandatoryAccessories().length }
              }}
            </span>
            {{ 'productDetails.pdpAddToBookingNotice_suffix' | transloco }}
          </ng-template>
        </p>
        <button
          class="btn btn-link view-accessories"
          type="button"
          (click)="addToCartLink()"
        >
          {{ 'productDetails.pdpViewAccessoriesLink' | transloco }}
        </button>
      </div>
    }

    <div class="break"></div>

    <div class="button-container">
      @if (product?.isBusiness) {
        <p class="business-notice">
          {{ 'productDetails.businessNotice' | transloco }}
        </p>
      }
      @defer {
        <boels-product-in-cart-label
          [$orderEntry]="$orderEntry()"
          [$product]="product"
          @fadeIn
        ></boels-product-in-cart-label>
        @if (
          !product.variantOptions &&
          product.stock?.stockLevelStatus !== 'outOfStock'
        ) {
          <boels-add-to-cart-button
            @fadeIn
            boelsSticky
            [stickyConfig]="{ title: product.name, hasButton: true }"
            [$product]="product"
            [$orderEntry]="$orderEntry()"
            [$buttonConfig]="{ variant: 'main', shape: 'pill' }"
          ></boels-add-to-cart-button>
        }
      }
    </div>
  </div>
}
